import { RANGE_TYPE } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

export function initialRangeType(rangeStart: string, rangeEnd: string): string {
  if (rangeStart && rangeEnd) {
    return RANGE_TYPE.between.toString()
  }
  if (rangeStart) {
    return RANGE_TYPE.more.toString()
  }
  return RANGE_TYPE.less.toString()
}
